module.exports = __webpack_public_path__ + "media/images/hero-allcare-banner-3840-a9586f511596e092f5f2ea0d4379aecc.webp";